export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 1.5a8.5 8.5 0 0 0-8.464 7.724l11.201.055-2.975-2.975a.75.75 0 0 1 1.061-1.06l4.253 4.253a.75.75 0 0 1 0 1.06l-4.22 4.221a.75.75 0 0 1-1.061-1.06l2.937-2.938-11.2-.055A8.5 8.5 0 0 0 20.5 12 8.5 8.5 0 0 0 12 3.5Z"/>
</svg>
`;
